import { ABVersionThumbnailV10 } from '@/components/ui/ABVersionThumbnailV10';

interface ABVersionPanelProps {
  readonly videoKeys: string[];
  readonly activeVersion: number;
  readonly versionsEnabled: boolean[];
  readonly isReadOnly: boolean;
  readonly onVersionChange: (i: number) => void;
  readonly onVersionToggle: (i: number) => void;
}

/**
 * Right-side panel showing A/B/C version thumbnails.
 * Only rendered when videoKeys.length > 1 (true multihook events).
 * For single videos, nothing is shown — avoids confusing locked B/C thumbnails.
 */
export function ABVersionPanel({
  videoKeys,
  activeVersion,
  versionsEnabled,
  isReadOnly,
  onVersionChange,
  onVersionToggle,
}: ABVersionPanelProps) {
  if (videoKeys.length <= 1) return null;

  return (
    <div className="flex-shrink-0 flex flex-col gap-3 items-center">
      {videoKeys.map((videoKey, i) => (
        <ABVersionThumbnailV10
          key={videoKey}
          label={String.fromCodePoint(65 + i)}
          s3Key={videoKey}
          isActive={activeVersion === i && versionsEnabled[i]}
          onClick={() => versionsEnabled[i] && onVersionChange(i)}
          disabled={!versionsEnabled[i]}
          showCheckbox={!isReadOnly}
          checked={versionsEnabled[i]}
          onCheckChange={() => onVersionToggle(i)}
        />
      ))}
    </div>
  );
}
